import {_show_infoWindow} from "../google-maps/_setup";

const _get_id_from_archive_link = ($archive_link) => {
    let regex = /inwestycja-(\d+)-link/i;
    let regex_array = regex.exec($archive_link.attr('id'));
    return regex_array !== null ? regex_array[1] : null;
};

export default function () {
    //region Selectory
    const inwestycje_lista_container = $('#inwestycje-lista');
    const inwestycje_objs = inwestycje_lista_container.find('.archive-link');
    //endregion Selectory

    //region Hovery i Focusy
    const mousein = (e) => {
        //mousein
        let inwestycja = $(e.target).closest('.archive-link');
        let post_id = _get_id_from_archive_link(inwestycja);
        let marker = google_map.markers[post_id];
        if (marker) {
            _show_infoWindow(google_map.map, marker, google_map.infowindow, google_map.infowindowContent, marker.title, marker.address);
        }
    };
    const mouseout = () => {
        //mouseout
        google_map.infowindow.close();
    };
    inwestycje_objs.hover(mousein, mouseout);
    inwestycje_objs.focusin(mousein);
    inwestycje_objs.focusout(mouseout);
    //endregion Hovery i Focusy
}

